import { Link } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import useLiveTheArt from "../hooks/useLiveTheArtMobile";
import { getLivetheart } from "../services/livetheArt.service";

function LivetheArtMobile() {
  const [banners, setBanners] = useState([]);
  const { leftImage, rightImage } = useLiveTheArt(banners);

  const sectionRef = useRef(null);
  const [progress, setProgress] = useState(0);

  // Fetch banners
  useEffect(() => {
    const fetchData = async () => {
      const data = await getLivetheart();
      setBanners(data);
    };
    fetchData();
  }, []);

  // Scroll-based progress
  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;

      const rect = sectionRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      // progress goes from 0 to 1 as section enters viewport
      const value = (windowHeight - rect.top) / (windowHeight + rect.height);
      const clamped = Math.max(0, Math.min(value, 1));
      setProgress(clamped);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // initialize

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Image starts at 100px, grows to 400px (matches container)
  const minHeight = 300;
  const maxHeight = 100;
  const getImageHeight = () => minHeight + progress * (maxHeight - minHeight);

  return (
    <section ref={sectionRef} className="Mobile-section_collection">

      {/* ROW 1 */}
      <div className="row-block">
        <div className="col text-block right-content">
          <h2 className="tagline">
            <em>Live the Art</em>
            <br />
            of&nbsp;Home
          </h2>

          <Link to="/collections">
            <button className="hero-button">CHECK OUR COLLECTIONS</button>
          </Link>
        </div>

        <div className="col image-block">
          {leftImage && (
            <div
              className="collection-img-wrap-mobile"
              style={{
                height: "180px", // fixed container
                width: "180px",
                // maxWidth: "260px",
                overflow: "hidden",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={leftImage}
                alt="Live Art Left"
                style={{
                  height: `${getImageHeight()}px`, // grows on scroll
                  width: "auto",
                  transition: "height 0.2s ease-out",
                }}
              />
            </div>
          )}
        </div>
      </div>

      {/* ROW 2 */}
      <div className="row-block">
        <div className="col image-block">
          {rightImage && (
            <div
              className="collection-img-wrap-mobile"
              style={{
                height: "180px", // fixed container
                width: "180px",
                // maxWidth: "260px",
                overflow: "hidden",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={rightImage}
                alt="Live Art Right"
                style={{
                  height: `${getImageHeight()}px`, // grows on scroll
                  width: "auto",
                  transition: "height 0.2s ease-out",
                }}
              />
            </div>
          )}
        </div>

        <div className="col text-block right-content">
          <p className="lead-copy">
            Every room tells a story, and the pieces you bring into it become
            part of the narrative. At Obsessions, we believe home is more than
            just a place; it’s a feeling.
          </p>
        </div>
      </div>

    </section>
  );
}

export default LivetheArtMobile;